'use client';

import FeaturesSection from '~/components/features-section';
import GetStartedSection from '~/components/get-started-section';
import HeroSection from '~/components/hero-section';
import HowItWorksSection from '~/components/how-it-works-section';
import { IdealCustomerSection } from '~/components/ideal-customer-section';
import WorkExamplesSection from '~/components/work-examples-section';
import { useState } from 'react';

export default function LandingPage() {
  const [quotePrefill, setQuotePrefill] = useState('');

  return (
    <>
      <HeroSection onQuotePrefill={setQuotePrefill} />
      <FeaturesSection id="services" />
      <IdealCustomerSection />
      <HowItWorksSection id="process" />
      <WorkExamplesSection id="work" />
      <GetStartedSection id="get-started" prefillNotes={quotePrefill} />
    </>
  );
}
